export enum DispEnum {
  OFF,
  ON,
}
